import { render, staticRenderFns } from "./CornerBadge.vue?vue&type=template&id=b7fd476e"
var script = {}
import style0 from "./CornerBadge.vue?vue&type=style&index=0&id=b7fd476e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports